import {
  VERIFY_EMAIL,
  VERIFY_EMAIL_SUCCESSFUL,
  VERIFY_EMAIL_FAILED
} from "./actionTypes";

const initialState = {
  message: null,
  loading: false,
  user: null,
  success: false,
  error: false
};

const VerifyEmail = (state = initialState, action) => {
  switch (action.type) {
    case VERIFY_EMAIL:
      state = {
        ...state,
        loading: true,
        message: null,
      };
      break;
    case VERIFY_EMAIL_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        user: action.payload.data,
        success: true,
        message: null,

      };
      break;
    case VERIFY_EMAIL_FAILED:
      state = {
        ...state,
        user: null,
        loading: false,
        message: action.payload,
        error: true
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default VerifyEmail;
